import styled from 'styled-components';

interface hasInput {
  inputPass?: React.ReactNode;
}

export const Container = styled.div`
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 260px;
  min-height: 320px;
  width: 100%;
  height: 100%;
  z-index: 9000;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
`;

export const Header = styled.div`
  width: 100%;
  height: 3.3rem;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background-color: #ff5b5b;

  span {
    font-size: 20px;
    font-weight: bold;
    color: #ffffff;
    text-align: center;
    text-overflow: ellipsis;
  }
`;

export const Body = styled.div<hasInput>`
  position: fixed;
  background: white;
  padding: 40px 60px 20px 60px;

  display: flex;
  flex-direction: column;
  align-items: center;

  max-width: 38rem;
  max-height: ${props => (props.inputPass ? '28rem' : '22rem')};
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 4px;
`;

export const UserData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  width: 100%;
  margin-top: 40px;

  span {
    font-size: 18px;
    font-weight: 500;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;
  text-align: center;
  font-size: 16px;

  p {
    color: black;
    font-size: 18px;

    width: 100%;
    height: 90%;
    padding: 40px 0px 20px 0px;
    text-align: justify;
    text-overflow: ellipsis;
  }
`;

export const InputContent = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  margin-top: 25px;
`;

export const ButtonsContainer = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
